import { PaintedScene } from '../PaintedScene';

export const COTTAGE_INTERIOR_PHASER_KEY = 'CottageInteriorScene' as const;
export const COTTAGE_INTERIOR_MANIFEST_KEY = 's-006-cottage-interior' as const;

export class CottageInteriorScene extends PaintedScene {
  constructor() {
    super(COTTAGE_INTERIOR_PHASER_KEY, COTTAGE_INTERIOR_MANIFEST_KEY);
  }
}
